
import { defineComponent } from "vue";
import authFooter from "@/modules/auth/components/authFooterComponent.vue";
import image from "../../../assets/images/icon-mail2.png";
import ResponseData from "../../../_models/ResponseData";
import XarcadeAccountService from "../../../services/XarcadeAccountService";
import { Helper } from "@/utils/Helper";

export default defineComponent({
  name: "viewAuthResetPassword",
    data: function () {
    return {
      image: image,
      activeSection : "forgotPassword",
      email: "",
    };
  },
  components: {
    authFooter,
  },
  methods: {
    forgotPassword() {
      this.activeSection = 'loadingForgotPassword';

      XarcadeAccountService.forgotPassword(this.email)
        .then((response: ResponseData) => {
          this.activeSection = "forgotPasswordSuccess";
          Helper.toastSuccessHandling(response.data['message']);
        })
        .catch((error) => {
          this.activeSection = "forgotPassword";
          this.errorSection = true;
          this.errorMessage = error.response.data["message"];
          this.errorMessage = Helper.endpointErrorHandling(error);
        });
    },
  },
});
